import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstateAgentProfileEdit = _resolveComponent("EstateAgentProfileEdit")!
  const _component_UserBasicProfileEdit = _resolveComponent("UserBasicProfileEdit")!

  return (_ctx.user.isEstateAgent)
    ? (_openBlock(), _createBlock(_component_EstateAgentProfileEdit, { key: 0 }))
    : (_openBlock(), _createBlock(_component_UserBasicProfileEdit, { key: 1 }))
}